import { render, staticRenderFns } from "./QuoteRequest.vue?vue&type=template&id=b829502e"
import script from "./QuoteRequest.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuoteRequest.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports